import { render, staticRenderFns } from "./StudentPopover.vue?vue&type=template&id=61121e9b&"
import script from "./StudentPopover.vue?vue&type=script&lang=js&"
export * from "./StudentPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports